export default {
  title: 'Ny menu',
  headers: {
    edit_time: 'Rediger tid',
  },
  labels: {
    select_all: 'Vælg alle',
  },
  fields: {
    name: {
      label: 'Navn',
      placeholder: 'Indtast menunavn',
    },
    sorting_order: {
      label: 'Menuens visningsrækkefølge',
      placeholder: 'Indtast menuens visningsrækkefølge',
    },
    has_separate_schedule: {
      label: 'Afviger fra de normale åbningstider',
    },
    selected_days: {
      label: 'Valgte dage',
    },
    opening_time: {
      label: 'Åbningstid',
    },
    closing_time: {
      label: 'Lukketid',
    },
  },
  buttons: {
    add_opening_time: 'Tilføj åbningstid',
    add: 'Tilføj',
    cancel: 'Annuller',
    save: 'Gem',
    close: 'Luk',
  },
  feedback: {
    missing_info: 'Manglende oplysninger',
  },
  toasts: {
    menu_got_created: 'Menuen er oprettet',
    menu_got_updated: 'Menuen er opdateret',
  },
};
